import { b as addItemById, a as contexts } from './cart-8130b675.js';
import { E as EVENTS } from './events-21b4b022.js';

class CrossSells extends HTMLElement {
  constructor() {
    super();

    this.selectors = {
      item: "[js-cross-sells-item]",
      itemAddButton: "[js-cross-sells-item-add]",
      itemError: "[js-cross-sells-item-error]",
    };

    this.classes = {
      active: "active",
      adding: "adding",
      hasError: "has-error",
    };
  }

  connectedCallback() {
    this.controller = new AbortController();
    this.itemAddButtons = this.querySelectorAll(this.selectors.itemAddButton);

    this.itemAddButtons.forEach((button) => {
      button.addEventListener("click", this.#handleItemAdd.bind(this), {
        signal: this.controller.signal,
      });

      // If the item has no variants, we need to listen for the cart error event
      if (button.dataset.hasVariants === "false") {
        const item = button.closest(this.selectors.item);

        item.addEventListener(
          EVENTS.QUICK_ADD_ERROR,
          this.#handleItemAddError.bind(this),
          { signal: this.controller.signal },
        );
      }
    });
  }

  #handleItemAdd(event) {
    event.preventDefault();

    const button = event.currentTarget;
    const item = button.closest(this.selectors.item);
    const hasVariants = button.dataset.hasVariants === "true";

    button.classList.add(this.classes.active, this.classes.adding);

    addItemById(
      button.dataset.variantId,
      1,
      contexts.productItem,
      item,
    );

    // TODO: conditionally addItemById only if !hasVariants and instead show quick view modal
    if (hasVariants) {
      setTimeout(() => {
        alert(
          "Will open quick view once built, for now, added first variant to cart",
        );
      }, 50);
    }
  }

  #handleItemAddError(event) {
    const button = event.target.querySelector(this.selectors.itemAddButton);
    const errorEl = event.target.querySelector(this.selectors.itemError);

    button.classList.remove(this.classes.active, this.classes.adding);
    errorEl.innerText = event.detail.errorMessage;
    event.target.classList.add(this.classes.hasError);
  }

  disconnectedCallback() {
    this.controller.abort();
  }
}

if (!customElements.get("cross-sells")) {
  customElements.define("cross-sells", CrossSells);
}
